import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { GetSurvey$Json$Params } from '../../api/fn/survey/get-survey-json';
import { ClientSurveyModel } from '../../api/models';
import { SurveyService } from '../../api/services';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-survey-detail',
  templateUrl: './survey-detail.component.html',
  styleUrls: ['./survey-detail.component.scss'],
})
export class SurveyDetailComponent implements OnInit {
  surveyId: number;
  matterNumber: string;
  month: number;
  year: number;

  isSurveyLoading = true;
  areSurveyVersionsLoading = true;

  survey: ClientSurveyModel;

  faCircleNotch = faCircleNotch;

  constructor(
    private route: ActivatedRoute,
    private toastService: ToastService,
    private surveyService: SurveyService
  ) {}

  ngOnInit() {
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('surveyId')!);
    this.matterNumber = this.route.snapshot.paramMap.get('matterNumber')!;
    this.month = parseInt(this.route.snapshot.paramMap.get('month')!);
    this.year = parseInt(this.route.snapshot.paramMap.get('year')!);

    if (this.surveyId) {
      this.loadSurveyDetails();
    } else {
      this.isSurveyLoading = false;
    }
  }

  loadSurveyDetails() {
    let params: GetSurvey$Json$Params = {
      surveyId: this.surveyId,
    };
    this.surveyService.getSurvey$Json$Response(params).subscribe({
      next: (r) => {
        this.isSurveyLoading = false;
        if (!r.body) {
          console.error(r.body);
          this.toastService.showToast(
            'danger',
            'Problem getting survey details'
          );
        } else {
          this.survey = r.body;
        }
      },
      error: (error) => {
        console.error(error, this);
        this.isSurveyLoading = false;
        this.toastService.showToast('danger', 'Problem getting survey details');
      },
    });
  }

  reloadSurveyDetails() {
    this.loadSurveyDetails();
  }
}
